module.exports = __webpack_public_path__ + "img/approving.2345aea9.svg";